import { render, staticRenderFns } from "./FCBR-dialog.vue?vue&type=template&id=a5b3b470&scoped=true"
import script from "./FCBR-dialog.vue?vue&type=script&lang=js"
export * from "./FCBR-dialog.vue?vue&type=script&lang=js"
import style0 from "./FCBR-dialog.vue?vue&type=style&index=0&id=a5b3b470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b3b470",
  null
  
)

export default component.exports